import { getLabelText } from "./autotrack/utils";
import { observeDocuments } from "../common/domObserver";

export function buttonClicks(
  callback: (
    _type: string,
    _text: string,
    _selectors: Record<string, string | null>
  ) => void
): () => void {
  const handleClickEvent = (e: MouseEvent): void => {
    if (e.type !== "click") return;
    let target: HTMLElement | null = e.target as HTMLElement;
    // get parent if target is a child of a button
    target = target.closest("button, a");
    if (target == null) return;

    // if (
    //   target.nodeName == "button" &&
    //   (target as HTMLButtonElement).type === "submit"
    // ) {
    //   // This is a form submit button, not just a click
    // }

    const href = target.getAttribute("href");
    const isButton =
      target.tagName === "BUTTON" ||
      target.tagName === "SPAN" ||
      (target.tagName === "A" && (href == null || href === "#"));
    if (isButton) {
      callback(target.tagName, getLabelText(target), {
        id: target.id,
        class: target.getAttribute("class"),
        href,
      });
    }
  };

  const handleCopyEvent = (e: Event): void => {
    const selection = document.getSelection();
    if (selection == null) return;
    const target = e.target as HTMLElement;
    callback("copy", selection.toString(), {
      id: target.id,
      class: target.getAttribute("class"),
    });
  };

  return observeDocuments((doc) => {
    doc.addEventListener("click", handleClickEvent, { capture: true });
    doc.addEventListener("copy", handleCopyEvent, { capture: true });

    return () => {
      doc.removeEventListener("click", handleClickEvent, { capture: true });
      doc.removeEventListener("copy", handleCopyEvent, { capture: true });
    };
  });
}
